import { useState } from "react";
import { Reveal, Overline } from "./Reveal";
import { useLang } from "@/i18n";
import { COMPANY } from "@/data";
import { Mail, Copy, Check } from "lucide-react";

const CopyButton = ({ value, label, copiedLabel }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {}
  };
  return (
    <button onClick={copy} data-testid={`copy-${label.toLowerCase().replace(/\s+/g, "-")}`}
      className="text-steel-500 hover:text-ember transition-colors duration-300 flex items-center gap-1 text-[10px] uppercase tracking-widest">
      {copied ? <Check size={12} className="text-ember" /> : <Copy size={12} />} {copied ? copiedLabel : label}
    </button>
  );
};

export const Billing = () => {
  const { t } = useLang();
  const invoiceEmail = COMPANY.invoiceEmail;

  return (
    <section id="billing" className="py-32 lg:py-40" data-testid="billing-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <Overline>{t("billing.overline")}</Overline>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">{t("billing.title")}</h2>
        </Reveal>

        <Reveal className="mt-16 max-w-3xl bg-surface border border-white/10 p-8 lg:p-10" data-testid="billing-email-card">
          <Mail size={22} className="text-ember" />
          <h3 className="mt-6 font-display text-xl font-semibold uppercase tracking-wide">{t("billing.emailTitle")}</h3>
          <p className="mt-3 text-sm text-steel-400">{t("billing.emailText")}</p>
          <div className="mt-6 flex items-center justify-between gap-4 bg-abyss border border-white/10 px-5 py-4">
            <a href={`mailto:${invoiceEmail}`} className="font-mono text-ember text-sm sm:text-base break-all" data-testid="billing-email-link">
              {invoiceEmail}
            </a>
            <CopyButton value={invoiceEmail} label={t("billing.copy")} copiedLabel={t("billing.copied")} />
          </div>
          <p className="mt-6 text-xs text-steel-500">
            {t("footer.contact")} : {COMPANY.phone} — Fax : {COMPANY.fax}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
